import '.eu{font-size:1.125rem;}.ssr-plugin'
import '.e2{line-height:1.75rem;}.ssr-plugin'
import '.i7{text-decoration:none;}.ssr-plugin'
import '.g1{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="eu e2"
    >
      {translations.privacySubtitle}{' '}
      <a className="i7 g1"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="i7 g1"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
